import PropTypes from 'prop-types';

export default function OutlineContacts(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M14.09 17.727v-1.636a3.273 3.273 0 0 0-3.272-3.273H4.273A3.273 3.273 0 0 0 1 16.091v1.636M7.546 9.545a3.273 3.273 0 1 0 0-6.545 3.273 3.273 0 0 0 0 6.545ZM19 17.727v-1.636a3.273 3.273 0 0 0-2.455-3.166M13.273 3.106a3.273 3.273 0 0 1 0 6.341"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineContacts.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
